<template>
  <div
    v-bind:style="showModal ? {display: 'block'} : {display: 'none'}"
    class="modal"
    id="exampleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-info modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{type}} descuento</h4>
          <button
            @click="close"
            class="close"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <form @submit.prevent="send()">
          <div class="modal-body">
            <b-col sm="12">
              <b-col sm="6">
                <div class="form-group">
                  <label>Requerimiento</label>
                  <input type="number" v-model="sinister.requeriment_id" class="form-control" required
                         @change="reqSearch()"/>
                </div>
                <div class="form-group">
                  <label for>Motivo</label>
                  <textarea type="text" v-model="sinister.reason" class="form-control" required></textarea>
                </div>
                <div class="form-group">
                  <label>Monto</label>
                  <input type="number" step="0.1" v-model="sinister.amount" class="form-control" required/>
                </div>
              </b-col>
            </b-col>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary">Guardar</button>
            <button @click="close" type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "@/helpers/api";
  import {mapGetters} from 'vuex'

  export default {
    name: "Modal",
    props: {
      showModal: {
        required: true
      },
      type: {
        required: true
      },
      sinister: {
        default() {
          return {
            reason: null,
            amount: 0.00,
            requeriment_id: null
          }
        }
      }
    },
    data() {
      return {};
    },
    computed: {
      ...mapGetters(
        {'user': 'user/user'}
      ),
    },
    methods: {
      send() {
        let data = {
          requeriment_id: this.sinister.requeriment_id,
          reason: this.sinister.reason,
          amount: this.sinister.amount,
          user_id: this.user.id
        }

        if (this.type === 'Nuevo') {
          api.post("/sinister", data).then(response => {
            if (response.success) {
              this.$toastr.success('Registrado', 'Siniestro', {
                positionClass: "toast-top-center",
                closeButton: true
              });
              this.close()
              this.$emit('onSaveNew', response.place)
            }
          });
        } else if (this.type === 'Editar') {
          api.put('/sinister/' + this.sinister.id, data).then(response => {
            if (response.success) {
              this.$toastr.success(`Editado`, 'Siniestro', {
                positionClass: "toast-top-center",
                closeButton: true
              });
              this.close()
              this.$emit('onSaveEdit', response.place)
            }
          });
        }
        this.sinister.reason = ''
        this.sinister.amount = '0.00'
        this.sinister.requeriment_id = ''
      },
      close() {
        this.sinister.reason = ''
        this.sinister.amount = '0.00'
        this.sinister.requeriment_id = ''
        this.$emit("close");
      },
      reqSearch() {
        api.get('/rq/' + this.sinister.requeriment_id).then(response => {
          if (!response.is_valid) {
            alert('No existe el requerimiento o ya está liquidado')
            this.sinister.requeriment_id = null
          }
        })
      }
    }
  };
</script>
